import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ConsultaChaveNFeRequest } from '../../requests/orquestrador-dfe/consulta-chave-nfe.request';
import { ConsultaChaveNFeResponse } from '../../responses/orquestrador-dfe/consulta-chave-nfe.response';

@Injectable({
  providedIn: 'root',
})
export class ConsultaChaveNFeService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  private readonly apiUrl = `${environment.urlApiOrquestradorDFe}ConsultaChaveNFe`;

  public consultar(request: ConsultaChaveNFeRequest): Observable<ConsultaChaveNFeResponse> {
    return this.httpClient
      .post<ConsultaChaveNFeResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
